<template>
  <!-- 底部图片容器 -->
  <div class="bottom-image-container">
    <img
      src="@/assets/LogoImages/Bottom-Logo.png"
      alt="Bottom Image"
      class="bottom-image"
    />
  </div>
</template>

<script>
export default {
  name: "BottomImages", // 修正了组件的名字，确保与实际使用一致
};
</script>

<style scoped>
/* 重置默认的外边距和内边距 */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box; /* 包括padding和border在内的宽度 */
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden; /* 防止水平滚动条 */
}

.bottom-image-container {
  width: 1200px; /* 固定宽度，像导航栏一样 */
  margin: 0 auto; /* 居中显示 */
  background-color: blue;
  padding: 0;
  display: flex;
  justify-content: center; /* 图片居中 */
  align-items: center; /* 如果需要垂直居中 */
  margin-top: 20px; /* 可选，确保图片与页面内容有一定间距 */
}

.bottom-image {
  width: 100%;
  height: auto;
  max-width: 100%; /* 确保图片不会超出容器宽度 */
}
</style>
